import { flatten } from '@higo/api/src/utils';
import { AzureResourceLinkDTO } from '@higo/api/src/azureResource/azureResourceLinkDTO';
import { AxiosInstance } from 'axios';

export const fetchAzureResourceLink =
  (axios: AxiosInstance) => (resourceId: number) =>
    axios
      .get<AzureResourceLinkDTO>(`api/files/${resourceId}/link`)
      .then(flatten);
